// main.js
import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './routes'
import 'vuetify/styles'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import store from './store/store'
import Echo from 'laravel-echo';
import axios from 'axios';
import Pusher from 'pusher-js';

// Load fonts
loadFonts();

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'e9e1be8fdb339d54908a',
    cluster: 'ap2',
    encrypted: true
});

// IMPORTANT: Set the base URL for Axios - use production URL
axios.defaults.baseURL  = process.env.VUE_APP_API_BASE_URL;

// Log to confirm
console.log('Axios baseURL set to:', axios.defaults.baseURL);

// Create Vue app
const app = createApp(App);

// Use plugins and router
app.use(router);
app.use(vuetify);
app.use(store);

app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAR0uKRBRjp_CYV746TYewoRUv0SiDuOxg',
        libraries: 'places',
    },
});

// Update the interceptor
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Don't redirect for region-code-list or other fallback endpoints
            const url = error.config.url || '';
            if (!url.includes('region-code-list') && !url.includes('area-code') && !url.includes('getDealerListRoute')) {
                router.push({ name: 'Login' });
            }
        }
        return Promise.reject(error);
    }
);

// Mount the app
app.mount('#app');